<template>
    <section id="content" class="gray-area">
        <div class="container">
            <!-- >>> 'BreadCrumbs' - Row -->
            <div class="row">
                <!-- >>> VueCmp - 'sdr-breadcrumbs', 'Breadcrumbs' -->
                <sdr-breadcrumbs active_item="third" :module="modulo"></sdr-breadcrumbs>
                <!-- <<< VueCmp - 'sdr-breadcrumbs', 'Breadcrumbs' -->
            </div>
            <!-- <<< 'BreadCrumbs' - Row -->


            <!-- >>> 'Payment' - Row -->
            <div class="row">
                <!-- >>>  Left Side: : 'Payment' -->
                <form @submit.prevent="onSubmit">
                    <div class="container shortcode travel-ideas">
                        <h1 class="idea-title" style="margin-bottom:20px;"><span class="index"><i class="soap-icon-arrow-right circle"></i></span>{{ pleaseselectpayment[getCurrentLocale] }}</h1>
                    </div>

                    <div id="main" class="col-sms-6 col-sm-8 col-md-9">
                        <div class="booking-section sdr-box">
                            <!-- >>> Payment: 'User' -->
                            <div class="person-information">
                                <h2>{{ yourpersonaldata[getCurrentLocale] }}:</h2>
                                <!-- >>> row: companyname -->
                                <div class="form-group row">
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ form_companyname[getCurrentLocale] }}:<small></small></label>
                                        <input type="text" class="input-text full-width"
                                            :class="{ invalid : $v.inputPax_company_payment.$error }"
                                            @input="$v.inputPax_company_payment.$touch()"
                                            v-model="inputPax_company_payment"
                                            id="inputPax_company_payment"
                                            name="inputPax_company_payment" value="" placeholder="" />
                                        <!-- >>> 'errormsg', company  -->
                                        <p class="errormsg" v-if="$v.inputPax_company_payment.$dirty && !$v.inputPax_company_payment.minLength">{{ errmsg_min_company[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPax_company_payment.$dirty && !$v.inputPax_company_payment.maxLength">{{ errmsg_max_company[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', company  -->
                                    </div>
                                </div>
                                <!-- <<< row: companyname -->

                                <!-- >>> row: salutation  -->
                                <div class="form-group row" style="margin-bottom:45px;">
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ form_salutation[getCurrentLocale] }}:*<small></small></label>
                                        <div class="selector">
                                            <select class="full-width" id="inputPax_salutation_payment" name="inputPax_salutation_payment">
                                                <option v-for="(sal, index) in buildSalutations()" v-bind:value="sal.value" v-bind:key="index">{{ sal.text }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <!-- <<< row: salutation  -->

                                <!-- >>> row: firstname (val:ok), lastname (val:ok) -->
                                <div class="form-group row">
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ form_firstname[getCurrentLocale] }}:* <small></small></label>
                                        <input type="text" class="input-text full-width"
                                            :class="{ invalid : $v.inputPax_firstName_payment.$error }"
                                            @input="$v.inputPax_firstName_payment.$touch()"
                                            v-model="inputPax_firstName_payment"
                                            id="'inputPax_firstName_payment"
                                            name="inputPax_firstName_payment" value="" placeholder="" />
                                        <!-- >>> 'errormsg', firstname -->
                                        <p class="errormsg" v-if="$v.inputPax_firstName_payment.$dirty && !$v.inputPax_firstName_payment.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPax_firstName_payment.$dirty && !$v.inputPax_firstName_payment.minLength">{{ errmsg_min_firstname[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPax_firstName_payment.$dirty && !$v.inputPax_firstName_payment.maxLength">{{ errmsg_max_firstname[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPax_firstName_payment.$dirty && !$v.inputPax_firstName_payment.letterspaces">{{ errmsg_letterspaces[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', firstname -->
                                    </div>

                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ form_lastname[getCurrentLocale] }}:* <small></small></label>
                                        <input type="text" class="input-text full-width"
                                            :class="{ invalid : $v.inputPax_lastName_payment.$error }"
                                            @input="$v.inputPax_lastName_payment.$touch()"
                                            v-model="inputPax_lastName_payment"
                                            id="inputPax_lastName_payment"
                                            name="inputPax_lastName_payment" value="" placeholder="" />
                                        <!-- >>> 'errormsg', lastname -->
                                        <p class="errormsg" v-if="$v.inputPax_lastName_payment.$dirty && !$v.inputPax_lastName_payment.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPax_lastName_payment.$dirty && !$v.inputPax_lastName_payment.minLength">{{ errmsg_min_lastname[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPax_lastName_payment.$dirty && !$v.inputPax_lastName_payment.maxLength">{{ errmsg_max_lastname[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPax_lastName_payment.$dirty && !$v.inputPax_lastName_payment.letterspaces">{{ errmsg_letterspaces[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', lastname -->
                                    </div>
                                </div>
                                <!-- <<< row: firstname (val:ok), lastname (val:ok) -->

                                <!-- >>> row: address (val:ok), plz (val:ok) -->
                                <div class="form-group row">
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ form_address[getCurrentLocale] }}:* <small></small></label>
                                        <input type="text" class="input-text full-width"
                                            :class="{ invalid : $v.inputPax_address_payment.$error }"
                                            @input="$v.inputPax_address_payment.$touch()"
                                            v-model="inputPax_address_payment"
                                            id="'inputPax_address_payment"
                                            name="inputPax_address_payment" value="" placeholder="" />
                                        <!-- >>> 'errormsg', address -->
                                        <p class="errormsg" v-if="$v.inputPax_address_payment.$dirty && !$v.inputPax_address_payment.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPax_address_payment.$dirty && !$v.inputPax_address_payment.minLength">{{ errmsg_min_lastname[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPax_address_payment.$dirty && !$v.inputPax_address_payment.maxLength">{{ errmsg_max_lastname[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', address -->
                                    </div>
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ form_plz[getCurrentLocale] }}:* <small></small></label>
                                        <input type="text" class="input-text full-width"
                                            :class="{ invalid : $v.inputPax_plz_payment.$error }"
                                            @input="$v.inputPax_plz_payment.$touch()"
                                            v-model="inputPax_plz_payment"
                                            id="inputPax_plz_payment"
                                            name="inputPax_plz_payment" value="" placeholder="" />
                                        <!-- >>> 'errormsg', plz -->
                                        <p class="errormsg" v-if="$v.inputPax_plz_payment.$dirty && !$v.inputPax_plz_payment.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPax_plz_payment.$dirty && !$v.inputPax_plz_payment.numeric">{{ errmsg_numeric[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPax_plz_payment.$dirty && !$v.inputPax_plz_payment.minLength">{{ errmsg_min_plz[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPax_plz_payment.$dirty && !$v.inputPax_plz_payment.maxLength">{{ errmsg_max_plz[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', plz -->
                                    </div>
                                </div>
                                <!-- <<< row: address (val:ok), plz (val:ok) -->

                                <!-- >>> row: residence (val:ok), country -->
                                <div class="form-group row">
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ form_residence[getCurrentLocale] }}:* <small></small></label>
                                        <input type="text" class="input-text full-width"
                                            :class="{ invalid : $v.inputPax_residence_payment.$error }"
                                            @input="$v.inputPax_residence_payment.$touch()"
                                            v-model="inputPax_residence_payment"
                                            id="'inputPax_residence_payment"
                                            name="inputPax_residence_payment" value="" placeholder="" />
                                        <!-- >>> 'errormsg', city -->
                                        <p class="errormsg" v-if="$v.inputPax_residence_payment.$dirty && !$v.inputPax_residence_payment.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPax_residence_payment.$dirty && !$v.inputPax_residence_payment.letterspaces">{{ errmsg_letterspaces[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPax_residence_payment.$dirty && !$v.inputPax_residence_payment.minLength">{{ errmsg_min_residence[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPax_residence_payment.$dirty && !$v.inputPax_residence_payment.maxLength">{{ errmsg_max_residence[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', city -->
                                    </div>
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ form_country[getCurrentLocale] }}:* <small></small></label>
                                        <div class="selector">
                                            <select class="full-width" id="inputPax_country_payment" name="inputPax_country_payment">
                                                <option v-for="(country, index) in buildCountries()" v-bind:value="country.id" v-bind:key="index">{{ country.country }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <!-- <<< row: residence (val:ok), country -->

                                <!-- >>> row: mobile (val:ok), phone (val:ok) -->
                                <div class="form-group row">
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ form_mobile[getCurrentLocale] }}:<small></small></label>
                                        <input type="text" class="input-text full-width"
                                            :class="{ invalid : $v.inputPax_mobile_payment.$error }"
                                            @input="$v.inputPax_mobile_payment.$touch()"
                                            v-model="inputPax_mobile_payment"
                                            id="'inputPax_mobile_payment"
                                            name="inputPax_mobile_payment" value="" placeholder="" />
                                        <!-- >>> 'errormsg', mobile  -->
                                        <p class="errormsg" v-if="$v.inputPax_mobile_payment.$dirty && !$v.inputPax_mobile_payment.numericspaces">{{ errmsg_numericspaces[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPax_mobile_payment.$dirty && !$v.inputPax_mobile_payment.minLength">{{ errmsg_min_phone[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPax_mobile_payment.$dirty && !$v.inputPax_mobile_payment.maxLength">{{ errmsg_max_phone[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', mobile  -->
                                    </div>
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ form_phone[getCurrentLocale] }}:* <small></small></label>
                                        <input type="text" class="input-text full-width"
                                            :class="{ invalid : $v.inputPax_phone_payment.$error }"
                                            @input="$v.inputPax_phone_payment.$touch()"
                                            v-model="inputPax_phone_payment"
                                            id="inputPax_phone_payment"
                                            name="inputPax_phone_payment" value="" placeholder="" />
                                        <!-- >>> 'errormsg', phone  -->
                                        <p class="errormsg" v-if="$v.inputPax_phone_payment.$dirty && !$v.inputPax_phone_payment.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPax_phone_payment.$dirty && !$v.inputPax_phone_payment.numericspaces">{{ errmsg_numericspaces[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPax_phone_payment.$dirty && !$v.inputPax_phone_payment.minLength">{{ errmsg_min_phone[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPax_phone_payment.$dirty && !$v.inputPax_phone_payment.maxLength">{{ errmsg_max_phone[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', phone  -->
                                    </div>
                                </div>
                                <!-- <<< row: mobile (val:ok), phone (val:ok) -->

                                <!-- >>> row: email (val:ok) -->
                                <div class="form-group row">
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ form_email[getCurrentLocale] }}:* <small></small></label>
                                        <input type="text" class="input-text full-width"
                                            :class="{ invalid : $v.inputPax_email_payment.$error }"
                                            @input="$v.inputPax_email_payment.$touch()"
                                            v-model="inputPax_email_payment"
                                            id="inputPax_email_payment"
                                            name="inputPax_email_payment" value="" placeholder="" />
                                        <!-- >>> 'errormsg', email -->
                                        <p class="errormsg" v-if="$v.inputPax_email_payment.$dirty && !$v.inputPax_email_payment.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="!$v.inputPax_email_payment.email">{{ errmsg_email[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', email -->
                                    </div>
                                </div>
                                <!-- <<< row: email (val:ok) -->
                            </div>
                            <!-- <<< Payment: 'User' -->



                            <br /><hr /><br />



                            <!-- >>> Payment: 'please choose payment method' (val:ok) -->
                            <div class="choose-information" v-if="!isItAnOOPayment">
                                <h2>{{ selectpaymentinfo[getCurrentLocale] }}:</h2>
                                <!-- >>> row: payment method  -->
                                <div class="form-group row">
                                    <div class="col-sm-12 col-md-10">
                                        <div class="selector">
                                            <select class="full-width"
                                                :class="{ invalid : !$v.inputPay_payment.required }"
                                                @input="$v.inputPay_payment.$touch()"
                                                v-model="inputPay_payment"
                                                id="inputPay_payment"
                                                name="inputPay_payment"
                                                @change="onChangePaymentMethod($event)">
                                                    <option value="">{{ this.paymentmethod_pleaseselect[this.getCurrentLocale]}}</option>
                                                    <option v-for="(sal, index) in buildPayments()" v-bind:value="sal.value" v-bind:key="index">{{ sal.text }}</option>
                                            </select>
                                            <!-- >>> 'errormsg', paymentchooser  -->
                                            <!-- <p v-if="!$v.inputPay_payment.required">&nbsp;</p> -->
                                            <p class="errormsg" v-if="!$v.inputPay_payment.required">{{ errmsg_required_2[getCurrentLocale] }}</p>
                                            <!-- <<< 'errormsg', paymentchooser  -->
                                        </div>
                                    </div>
                                </div>
                                <!-- <<< row: payment method  -->
                                <br /><br /><hr /><br />

                            </div>
                            <!-- <<< Payment: 'please choose payment method' (val:ok) -->




                            <!-- >>> Payment: 'CreditCard' -->
                            <div class="card-information" v-show="showCreditcardFake">
                                <h2>{{ yourcardinfo[getCurrentLocale] }}:</h2>
                                <!-- >>> row: cc_type, cc_holder (val:ok) -->
                                <div class="form-group row">
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ form_cc_type[getCurrentLocale] }}:<span style="color: red; font-size:14px;">*</span></label>
                                        <div class="selector">
                                            <select class="full-width" id="inputPayment_cc_type" name="inputPayment_cc_type">
                                                <option v-for="(card, index) in buildCreditcards()" v-bind:value="card.id" v-bind:key="index">{{
                                                    card.card }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ form_cc_holder[getCurrentLocale] }}:<span style="color: red; font-size:14px;">*</span></label>
                                        <input type="text" class="input-text full-width" :class="{ invalid: $v.inputPayment_cc_holder.$error }"
                                            @input="$v.inputPayment_cc_holder.$touch()" v-model="inputPayment_cc_holder"
                                            id="'inputPayment_cc_holder" name="inputPayment_cc_holder" value="" placeholder="" />
                                        <!-- >>> 'errormsg', cc_holder -->
                                        <p class="errormsg" v-if="$v.inputPayment_cc_holder.$dirty && !$v.inputPayment_cc_holder.required">
                                            {{ errmsg_required[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPayment_cc_holder.$dirty && !$v.inputPayment_cc_holder.minLength">
                                            {{ errmsg_min_company[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPayment_cc_holder.$dirty && !$v.inputPayment_cc_holder.maxLength">
                                            {{ errmsg_max_company[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPayment_cc_holder.$dirty && !$v.inputPayment_cc_holder.letterspaces">
                                            {{ errmsg_letterspaces[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', cc_holder -->
                                    </div>
                                </div>
                                <!-- <<< row: cc_type, cc_holder (val:ok) -->

                                <!-- >>> row: cc_number (val:ok), cc_cvc (val:ok) -->
                                <div class="form-group row">
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ form_cc_number[getCurrentLocale] }}:<span style="color: red; font-size:14px;">*</span></label>
                                        <input type="text" class="input-text full-width" :class="{ invalid: $v.inputPayment_cc_number.$error }"
                                            @input="$v.inputPayment_cc_number.$touch()" v-model="inputPayment_cc_number"
                                            id="'inputPayment_cc_number" name="inputPayment_cc_number" value="" placeholder="" />
                                        <!-- >>> 'errormsg', cc_number -->
                                        <p class="errormsg" v-if="$v.inputPayment_cc_number.$dirty && !$v.inputPayment_cc_number.required">
                                            {{ errmsg_required[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPayment_cc_number.$dirty && !$v.inputPayment_cc_number.minLength">
                                            {{ errmsg_min_ccnumber[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPayment_cc_number.$dirty && !$v.inputPayment_cc_number.maxLength">
                                            {{ errmsg_max_ccnumber[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', cc_number -->
                                    </div>
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ form_cc_cvc[getCurrentLocale] }}:<span style="color: red; font-size:14px;">*</span></label>
                                        <input type="text" class="input-text full-width" :class="{ invalid: $v.inputPayment_cc_cvc.$error }"
                                            @input="$v.inputPayment_cc_cvc.$touch()" v-model="inputPayment_cc_cvc" id="'inputPayment_cc_cvc"
                                            name="inputPayment_cc_cvc" value="" placeholder="" />
                                        <!-- >>> 'errormsg', cc_number -->
                                        <p class="errormsg" v-if="$v.inputPayment_cc_cvc.$dirty && !$v.inputPayment_cc_cvc.required">{{
                                            errmsg_required[getCurrentLocale]
                                            }}</p>
                                        <p class="errormsg" v-if="$v.inputPayment_cc_cvc.$dirty && !$v.inputPayment_cc_cvc.numeric">{{
                                            errmsg_numeric[getCurrentLocale]
                                            }}</p>
                                        <p class="errormsg" v-if="$v.inputPayment_cc_cvc.$dirty && !$v.inputPayment_cc_cvc.minLength">{{
                                            errmsg_min_cccvc[getCurrentLocale]
                                            }}</p>
                                        <p class="errormsg" v-if="$v.inputPayment_cc_cvc.$dirty && !$v.inputPayment_cc_cvc.maxLength">{{
                                            errmsg_max_cccvc[getCurrentLocale]
                                            }}</p>
                                        <!-- <<< 'errormsg', cc_number -->
                                    </div>
                                </div>
                                <!-- <<< row: cc_number (val:ok), cc_cvc (val:ok) -->

                                <!-- >>> row: cc_expirationdate -->
                                <div class="form-group row">
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ form_cc_expirationdate[getCurrentLocale] }}:<span
                                                style="color: red; font-size:14px;">*</span></label>
                                        <div class="constant-column-2">
                                            <div class="selector">
                                                <select class="full-width" id="inputPayment_cc_expirationmonth"
                                                    name="inputPayment_cc_expirationmonth">
                                                    <option v-for="(month, index) in buildMonths()" v-bind:value="month.value" v-bind:key="index">{{
                                                        month.text }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="selector">
                                                <select class="full-width" id="inputPayment_cc_expirationyear"
                                                    name="inputPayment_cc_expirationyear">
                                                    <option v-for="(year, index) in buildYears()" v-bind:value="year.value" v-bind:key="index">{{
                                                        year.text }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <<< row: cc_expirationdate -->

                                <p style="color: red;">{{ creditcardnote[getCurrentLocale] }}</p>
                                <p style="color: red;">{{ creditcardnote2[getCurrentLocale] }}</p>
                            </div>
                            <div class="card-information" v-show="showCreditcard">
                                <p style="color: red;">{{ creditcardnote[getCurrentLocale] }}</p>
                                <p style="color: red;">{{ creditcardnote2[getCurrentLocale] }}</p>
                            </div>
                            <!-- <<< Payment: 'CreditCard' -->


                            <!-- >>> Payment: 'Debit' -->
                            <div class="debit-information" v-show="showDebit">
                                <h2>{{ yourdebitinfo[getCurrentLocale] }}:</h2>
                                <!-- >>> row: dd_accountholder (val:ok) -->
                                <div class="form-group row">
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ form_dd_accountholder[getCurrentLocale] }}:* <small></small></label>
                                        <input type="text" class="input-text full-width"
                                            :class="{ invalid : $v.inputPayment_dd_accountholder.$error }"
                                            @input="$v.inputPayment_dd_accountholder.$touch()"
                                            v-model="inputPayment_dd_accountholder"
                                            id="'inputPayment_dd_accountholder"
                                            name="inputPayment_dd_accountholder" value="" placeholder="" />
                                        <!-- >>> 'errormsg', dd_accountholder -->
                                        <p class="errormsg" v-if="$v.inputPayment_dd_accountholder.$dirty && !$v.inputPayment_dd_accountholder.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPayment_dd_accountholder.$dirty && !$v.inputPayment_dd_accountholder.minLength">{{ errmsg_min_company[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPayment_dd_accountholder.$dirty && !$v.inputPayment_dd_accountholder.maxLength">{{ errmsg_min_company[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPayment_dd_accountholder.$dirty && !$v.inputPayment_dd_accountholder.letterspaces">{{ errmsg_letterspaces[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', dd_accountholder -->
                                    </div>
                                </div>
                                <!-- <<< row: dd_accountholder (val:ok) -->

                                <!-- >>> row: dd_iban (val:ok), dd_bic (val:ok) -->
                                <div class="form-group row">
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ form_dd_iban[getCurrentLocale] }}:* <small></small></label>
                                        <input type="text" class="input-text full-width"
                                            :class="{ invalid : $v.inputPayment_dd_iban.$error }"
                                            @input="$v.inputPayment_dd_iban.$touch()"
                                            v-model="inputPayment_dd_iban"
                                            id="'inputPayment_dd_iban"
                                            name="inputPayment_dd_iban" value="" placeholder="" />
                                        <!-- >>> 'errormsg', dd_iban -->
                                        <p class="errormsg" v-if="$v.inputPayment_dd_iban.$dirty && !$v.inputPayment_dd_iban.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPayment_dd_iban.$dirty && !$v.inputPayment_dd_iban.alphaNum">{{ errmsg_alphanum[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPayment_dd_iban.$dirty && !$v.inputPayment_dd_iban.minLength">{{ errmsg_min_iban[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPayment_dd_iban.$dirty && !$v.inputPayment_dd_iban.maxLength">{{ errmsg_min_iban[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPayment_dd_iban.$dirty && !$v.inputPayment_dd_iban.ibanletters">{{ errmsg_countrycode_iban[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', dd_iban -->
                                    </div>
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ form_dd_bic[getCurrentLocale] }}:* <small></small></label>
                                        <input type="text" class="input-text full-width"
                                            :class="{ invalid : $v.inputPayment_dd_bic.$error }"
                                            @input="$v.inputPayment_dd_bic.$touch()"
                                            v-model="inputPayment_dd_bic"
                                            id="'inputPayment_dd_bic"
                                            name="inputPayment_dd_bic" value="" placeholder="" />
                                        <!-- >>> 'errormsg', dd_iban -->
                                        <p class="errormsg" v-if="$v.inputPayment_dd_bic.$dirty && !$v.inputPayment_dd_bic.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPayment_dd_bic.$dirty && !$v.inputPayment_dd_bic.alphaNum">{{ errmsg_alphanum[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPayment_dd_bic.$dirty && !$v.inputPayment_dd_bic.minLength">{{ errmsg_min_bic[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputPayment_dd_bic.$dirty && !$v.inputPayment_dd_bic.maxLength">{{ errmsg_min_bic[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', dd_iban -->
                                    </div>
                                </div>
                                <!-- <<< row: dd_iban (val:ok), dd_bic (val:ok) -->
                            </div>
                            <!-- <<< Payment: 'Debit' -->


                            <!-- >>> Payment: 'Cash' -->
                            <div v-show="showCash">
                                <h2>{{ yourcashinfo[getCurrentLocale] }}:</h2>

                                <h3 style="color: red;">{{ cashnote[getCurrentLocale] }}</h3>
                            </div>
                            <!-- <<< Payment: 'Cash' -->


                            <span v-show="showCreditcard || showDebit"><br /><hr /></span>

                        </div>


                        <br />
                        <button type="submit" class="btn-large icon-check uppercase full-width" v-if="checkValidity()" v-bind:class="{ sundairsrvcs: modulo === 'services', 'icon-check3': modulo === 'services' }">{{ proceed[getCurrentLocale] }}</button>
                        <a class="button btn-large uppercase full-width silver" v-if="!checkValidity()">{{ proceed[getCurrentLocale] }}</a>
                    </div>
                </form>
                <!-- <<<  Left Side: : 'Payment' -->



                <!-- >>>  Right Side: Sidebar, 'Payment' -->
                <div class="sidebar col-sms-6 col-sm-4 col-md-3">
                    <!-- >>> VueCmp - 'sdr-shared-cart', 'Shared Cart' -->
                    <sdr-shared-cart :modulo="modulo"></sdr-shared-cart>
                    <!-- <<< VueCmp - 'sdr-shared-cart', 'Shared Cart' -->


                    <!-- >>> VueCmp - 'sdr-contact-box', 'Contact Box' -->
                    <sdr-contact-box></sdr-contact-box>
                    <!-- <<< VueCmp - 'sdr-contact-box', 'Contact Box' -->
                </div>
                <!-- <<<  Right Side: Sidebar, 'Payment' -->
            </div>
            <!-- <<< 'Payment' - Row -->
        </div>
    </section>
</template>

<script>
    import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs.vue';
    import ContactBox from '../../shared/sidebar/ContactBox.vue';
    import SharedCart from '../../shared/cart/Cart.vue';

    import { helpers, required, minLength, maxLength, numeric, alphaNum, email } from 'vuelidate/lib/validators';
    const letterspaces = helpers.regex('letterspaces', /^[a-z-öÖüÜäÄ\s]+$/i);    /* Validator */
    const numericspaces = helpers.regex('numericspaces', /^[0-9+/\s]+$/i);       /* Validator */
    const ibanletters = helpers.regex('ibanletters', /^DE\d+$/i);               /* Validator, 'DE' only */

    import { mapActions, mapGetters } from 'vuex';
    import moment from 'moment';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo'], // via: router/push
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-breadcrumbs': Breadcrumbs,
            'sdr-contact-box': ContactBox,
            'sdr-shared-cart': SharedCart,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                pleaseselectpayment: {
                    en: 'Step 3: Please enter your payment details.',
                    de: 'Schritt 3: Bitte geben Sie Ihre Zahldaten an.'
                },
                // >>> --------------------------
                yourpersonaldata: {
                    en: 'Your personal information',
                    de: 'Ihre persönlichen Daten',
                },
                selectpaymentinfo: {
                    en: 'Please choose payment method',
                    de: 'Bitte wählen Sie Ihre Zahlart',
                },
                // >>> --------------------------
                yourcardinfo: {
                    en: 'Your Card Informations',
                    de: 'Ihre Kreditkarten Informationen',
                },
                yourdebitinfo: {
                    en: 'Your Debit Informations',
                    de: 'Ihre Lastschrift Informationen',
                },
                yourcashinfo: {
                    en: 'Your Cash Payment Informations',
                    de: 'Ihre Barzahlungs-Informationen',
                },
                cashnote: {
                    en: 'Attention: Agency is doin Cash Payment.',
                    de: 'Achtung: Agentur macht Barzahlung.',
                },
                // >>> --------------------------
                form_mr: {
                    en: 'Mr.',
                    de: 'Herr',
                },
                form_mrs: {
                    en: 'Mrs.',
                    de: 'Frau',
                },
                // >>> --------------------------
                form_companyname: {
                    en: 'Company name',
                    de: 'Firmenname',
                },
                form_salutation: {
                    en: 'Salutation',
                    de: 'Anrede',
                },
                form_firstname : {
                    en: 'First name',
                    de: 'Vorname',
                },
                form_lastname : {
                    en: 'Last name',
                    de: 'Nachname',
                },
                form_address : {
                    en: 'Address',
                    de: 'Adresse',
                },
                form_plz : {
                    en: 'Zip code',
                    de: 'PLZ',
                },
                form_residence: {
                    en: 'City',
                    de: 'Wohnort',
                },
                form_country: {
                    en: 'Country',
                    de: 'Land',
                },
                form_mobile: {
                    en: 'Mobile phone',
                    de: 'Handynummer',
                },
                form_phone: {
                    en: 'Phone number',
                    de: 'Telefonnummer',
                },
                form_email: {
                    en: 'E-Mail',
                    de: 'E-Mail',
                },
                form_promo_1: {
                    en: 'I want to receive',
                    de: 'Ich möchte in Zukunft ',
                },
                form_promo_2: {
                    en: 'promotional offers in the future.',
                    de: 'Werbeangebote erhalten.',
                },
                // >>> --------------------------
                form_cc_type: {
                    en: 'Credit Card Type',
                    de: 'Kreditkartentyp',
                },
                form_cc_holder: {
                    en: 'Card Holder Name',
                    de: 'Karteninhaber',
                },
                form_cc_number: {
                    en: 'Card Number',
                    de: 'Kartennummer',
                },
                form_cc_cvc: {
                    en: 'Card identification number',
                    de: 'CVC Code',
                },
                form_cc_expirationdate: {
                    en: 'Expiration Date',
                    de: 'Gültig bis',
                },
                // >>> --------------------------
                form_dd_accountholder: {
                    en: 'Account holder',
                    de: 'Kontoinhaber',
                },
                form_dd_iban: {
                    en: 'IBAN',
                    de: 'IBAN',
                },
                form_dd_bic: {
                    en: 'BIC',
                    de: 'BIC',
                },
                // >>> --------------------------
                paymentmethod_pleaseselect: {
                    en: 'Please select',
                    de: 'Bitte auswählen',
                },
                paymentmethod_cc: {
                    en: 'Creditcard',
                    de: 'Kreditkarte',
                },
                paymentmethod_dd: {
                    en: 'Direct Debit',
                    de: 'Lastschrift',
                },
                paymentmethod_cs: {
                    en: 'Cash Payment',
                    de: 'Barzahlung',
                },
                // >>> --------------------------
                creditcardnote: {
                    en: 'Credit card payments will appear on your bank statement as Air41 GmbH, Taunusstrasse 1,14193 Berlin.',
                    de: 'Kreditkartenzahlungen werden auf Ihrem Kontoauszug als Air41 GmbH, Taunusstraße 1,14193 Berlin, ausgewiesen.',
                },
                creditcardnote2: {
                    en: 'Important note: Please make sure that your credit card is activated for 3D Secure payment.',
                    de: 'Wichtiger Hinweis: Bitte stellen Sie sicher, dass ihre Kreditkarte für die 3D Secure Zahlung freigeschaltet ist.',
                },
                // >>> --------------------------
                january: {
                    en: 'January',
                    de: 'Januar',
                },
                february: {
                    en: 'February',
                    de: 'Februar',
                },
                march: {
                    en: 'March',
                    de: 'März',
                },
                april: {
                    en: 'April',
                    de: 'April',
                },
                may: {
                    en: 'May',
                    de: 'Mai',
                },
                june: {
                    en: 'June',
                    de: 'Juni',
                },
                july: {
                    en: 'July',
                    de: 'Juli',
                },
                august: {
                    en: 'August',
                    de: 'August',
                },
                september: {
                    en: 'September',
                    de: 'September',
                },
                october: {
                    en: 'October',
                    de: 'Oktober',
                },
                november: {
                    en: 'November',
                    de: 'November',
                },
                december: {
                    en: 'December',
                    de: 'Dezember',
                },
                // >>> --------------------------
                // >>> --------------------------
                errmsg_required: {
                    en: 'This Field must not be empty.',
                    de: 'Dieses Feld darf nicht leer sein.',
                },
                errmsg_required_2: {
                    en: 'Please choose your payment method.',
                    de: 'Bitte wählen Sie Ihre Zahlart.',
                },
                // >>> --------------------------
               errmsg_letterspaces: {
                    en: 'Letters, "-" and spaces are allowed.',
                    de: 'Erlaubt sind Buchstaben, “-“ und Leerzeichen.',
                },
                // >>> --------------------------
                errmsg_numericspaces: {
                    en: 'Numbers, "+/" and spaces are allowed.',
                    de: 'Erlaubt sind Zahlen, “+/“ und Leerzeichen.',
                },
                // >>> --------------------------
               errmsg_numeric: {
                    en: 'Only numbers are allowed.',
                    de: 'Es sind nur Zahlen erlaubt.',
                },
                errmsg_alphanum: {
                    en: 'Only numbers and letters are allowed.',
                    de: 'Erlaubt sind nur Zahlen und Buchstaben.',
                },
                // >>> --------------------------
                errmsg_min_firstname : {
                    en: 'Allowed length: 2-30 characters.',
                    de: 'Erlaubte Länge: 2-30 Zeichen.',
                },
                errmsg_max_firstname: {
                    en: 'Allowed length: 2-30 characters.',
                    de: 'Erlaubte Länge: 2-30 Zeichen.',
                },
                // >>> --------------------------
                errmsg_min_lastname : {
                    en: 'Allowed length: 2-60 characters.',
                    de: 'Erlaubte Länge: 2-60 Zeichen.',
                },
                errmsg_max_lastname: {
                    en: 'Allowed length: 2-60 characters.',
                    de: 'Erlaubte Länge: 2-60 Zeichen.',
                },
                // >>> --------------------------
                errmsg_min_plz : {
                    en: 'Allowed length: 4-8 characters.',
                    de: 'Erlaubte Länge: 4-8 Zeichen.',
                },
                errmsg_max_plz: {
                    en: 'Allowed length: 4-8 characters.',
                    de: 'Erlaubte Länge: 4-8 Zeichen.',
                },
                // >>> --------------------------
                errmsg_min_residence: {
                    en: 'Allowed length: 2-30 characters.',
                    de: 'Erlaubte Länge: 2-30 Zeichen.',
                },
                errmsg_max_residence: {
                    en: 'Allowed length: 2-30 characters.',
                    de: 'Erlaubte Länge: 2-30 Zeichen.',
                },
                // >>> --------------------------
                errmsg_min_phone: {
                    en: 'Allowed length: 5-18 characters.',
                    de: 'Erlaubte Länge: 5-18 Zeichen.',
                },
                errmsg_max_phone: {
                    en: 'Allowed length: 5-18 characters.',
                    de: 'Erlaubte Länge: 5-18 Zeichen.',
                },
                // >>> --------------------------
                errmsg_email: {
                    en: 'Please provide valid e-mail.',
                    de: 'Bitte geben Sie eine gültige E-Mail an.',
                },
                // >>> --------------------------
                errmsg_min_company: {
                    en: 'Allowed length: 2-90 characters.',
                    de: 'Erlaubte Länge: 2-90 Zeichen.',
                },
                errmsg_max_company: {
                    en: 'Allowed length: 2-90 characters.',
                    de: 'Erlaubte Länge: 2-90 Zeichen.',
                },
                // >>> --------------------------
                errmsg_min_iban: {
                    en: 'Allowed length: 22 characters.',
                    de: 'Erlaubte Länge: 22 Zeichen.',
                },
                errmsg_max_iban: {
                    en: 'Allowed length: 22 characters.',
                    de: 'Erlaubte Länge: 22 Zeichen.',
                },
                errmsg_countrycode_iban: {
                    en: 'Only IBAN starting with DE are allowed.',
                    de: 'Erlaubt sind nur IBAN beginnend mit DE.',
                },
                // >>> --------------------------
                errmsg_min_bic: {
                    en: 'Allowed length: 8-11 characters.',
                    de: 'Erlaubte Länge: 8-11 Zeichen.',
                },
                errmsg_max_bic: {
                    en: 'Allowed length: 8-11 characters.',
                    de: 'Erlaubte Länge: 8-11 Zeichen.',
                },
                // >>> --------------------------
                errmsg_min_ccnumber: {
                    en: 'Allowed length: 12-16 characters.',
                    de: 'Erlaubte Länge: 12-16 Zeichen.',
                },
                errmsg_max_ccnumber: {
                    en: 'Allowed length: 12-16 characters.',
                    de: 'Erlaubte Länge: 12-16 Zeichen.',
                },
                // >>> --------------------------
                errmsg_min_cccvc: {
                    en: 'Allowed length: 3-4 characters.',
                    de: 'Erlaubte Länge: 3-4 Zeichen.',
                },
                errmsg_max_cccvc: {
                    en: 'Allowed length: 3-4 characters.',
                    de: 'Erlaubte Länge: 3-4 Zeichen.',
                },
                // >>> --------------------------
                // >>> --------------------------
                proceed: {
                    en: 'PROCEED TO YOUR BOOKING OVERVIEW',
                    de: 'WEITER ZU IHRER BUCHUNGSÜBERSICHT',
                },
                // currentLocale: 'de',
                // >>> --------------------------
                showCreditcard: false,
                showCreditcardFake: false,
                showDebit: false,
                showCash: false,
                paymentParams: {}, //

                // >>> -------------------------- 'Form / Model / Vuelidate'
                inputPax_firstName_payment: '',
                inputPax_lastName_payment: '',
                inputPax_address_payment: '',
                inputPax_plz_payment: '',
                inputPax_residence_payment: '',
                inputPax_phone_payment: '',
                inputPax_mobile_payment: '', // not required
                inputPax_company_payment: '', // not required
                inputPax_email_payment: '',

                inputPay_payment: '',

                inputPayment_cc_holder: '',
                inputPayment_cc_number: '',
                inputPayment_cc_cvc: '',

                inputPayment_dd_accountholder: '',
                inputPayment_dd_iban: '',
                inputPayment_dd_bic: '',
                // >>> --------------------------
                isItAnOOPayment: false
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Validations */
        validations: {

            // >>> firstname --------------------
            inputPax_firstName_payment: {
                required: required,
                minLength: minLength(2),
                maxLength: maxLength(30),
                letterspaces: letterspaces
            },

            // >>> lastname ---------------------
            inputPax_lastName_payment: {
                required: required,
                minLength: minLength(2),
                maxLength: maxLength(60),
                letterspaces: letterspaces
            },

            // >>> address ----------------------
            inputPax_address_payment: {
                required: required,
                minLength: minLength(2),
                maxLength: maxLength(60),
            },

            // >>> plz --------------------------
            inputPax_plz_payment: {
                required: required,
                numeric: numeric,
                minLength: minLength(4),
                maxLength: maxLength(8),
            },

            // >>> city -------------------------
            inputPax_residence_payment: {
                required: required,
                minLength: minLength(2),
                maxLength: maxLength(30),
                letterspaces: letterspaces
            },

            // >>> phone ------------------------
            inputPax_phone_payment: {
                required: required,
                minLength: minLength(5),
                maxLength: maxLength(18),
                numericspaces: numericspaces
            },

            // >>> email ------------------------
            inputPax_email_payment: {
                required: required,
                email: email,
            },

            // >>> mobile ----------------------- not required
            inputPax_mobile_payment: {
                minLength: minLength(5),
                maxLength: maxLength(18),
                numericspaces: numericspaces
            },

            // >>> company ---------------------- not required
            inputPax_company_payment: {
                minLength: minLength(2),
                maxLength: maxLength(90),
            },



            // >>> paymentchooser ---------------
            inputPay_payment: {
                required: required,
            },



            // >>> cc holder -------------------
            inputPayment_cc_holder: {
                required: required,
                minLength: minLength(2),
                maxLength: maxLength(90),
                letterspaces: letterspaces
            },

            // >>> cc number -------------------
            inputPayment_cc_number: {
                required: required,
                minLength: minLength(15),
                maxLength: maxLength(19),
            },

            // >>> cc cbc -----------------------
            inputPayment_cc_cvc: {
                required: required,
                numeric: numeric,
                minLength: minLength(3),
                maxLength: maxLength(4),
            },



            // >>> dd holder -------------------
            inputPayment_dd_accountholder: {
                required: required,
                minLength: minLength(2),
                maxLength: maxLength(90),
                letterspaces: letterspaces
            },

            // >>> dd iban ---------------------
            inputPayment_dd_iban: {
                required: required,
                alphaNum: alphaNum,
                minLength: minLength(22),
                maxLength: maxLength(22),
                ibanletters: ibanletters,
            },

            // >>> dd bic ---------------------
            inputPayment_dd_bic: {
                required: required,
                alphaNum: alphaNum,
                minLength: minLength(8),
                maxLength: maxLength(11),
            },



        }, // eof validations{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                // >>> --------------------------
                'getFlagBookingPaymentIsReadyForOverview',
                'getBookingLockfaresResults',
                'getBookingValidatePassengersObject',
                // >>> --------------------------
                'getServicesBookingOptions', // (same for 'Services')
                'getServicesValidatePassengersObject', // (same for 'Services')
                'getServicesValidatePassengersObjectClone', // (same for 'Services' Clone)
                // >>> --------------------------
                'getBookingUsersSearchData',
                'getBookingCartOutwardTotal',
                'getBookingCartReturnTotal',
                'getBookingCartCountServices', // #340
                'get_areWeInServicesBookingNoMode',
                'get_ServicesUsersSearchDataBookingno',
                'get_ServicesBookingnoSearchResults',

                'getServicesProcessBookingObject',
                'getBookingFlightIdSelectedOutward',
                'getBookingFlightIdSelectedReturn',
                // >>> --------------------------
                'getFlagSharedAgencyLoggedIn', // Agency is logged in?
                'getSharedAgencyLoginResultsAgencyObject',
            ]),


            /*******************************************************************
            * paymentParamsData
            *
            * Desc: 'Validate Passengers Object' for Call of same Name.
            * Note:
            *
            */
            paymentParamsData : {

                get() {
                    return this.paymentParams;
                },
                set(value) {
                    this.paymentParams = value;
                }

            }, // eof paymentParamsData{}

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc: Initialize Select Fields.
        * Note: Check here if Agency is logged in.
        * Note: Prefill Agency here.
        *
        */
        mounted: function() {

            var me = this,
                agencyObject = null;


            me.$toc('>>> booking/payment/Payment.vue >>> mounted');
            me.$selectInits(this.modulo);

            // >>> -------------------------- OOPayment ?
            if (this.modulo === 'services') {
                if (this.getBookingUsersSearchData.rTrip === true) { // Roundtrip
                    if (this.getBookingCartOutwardTotal === 0 && this.getBookingCartReturnTotal === 0 && this.getBookingCartCountServices > 0 ) {
                        this.isItAnOOPayment = true;
                    }
                }
                if (this.getBookingUsersSearchData.rTrip === false) { // Oneway
                    if (this.getBookingCartOutwardTotal === 0 && this.getBookingCartCountServices > 0 ) {
                        this.isItAnOOPayment = true;
                    }
                }
            }

            // >>> -------------------------- Agency logged in? Prefill!
            if (this.getFlagSharedAgencyLoggedIn === true) {
                agencyObject = JSON.parse(this.getSharedAgencyLoginResultsAgencyObject);

                this.inputPax_firstName_payment = agencyObject.firstName;
                this.inputPax_lastName_payment  = agencyObject.lastName;
                this.inputPax_address_payment   = agencyObject.address;
                this.inputPax_plz_payment       = agencyObject.plz;
                this.inputPax_residence_payment = agencyObject.city;
                this.inputPax_phone_payment     = agencyObject.phone;
                this.inputPax_email_payment     = agencyObject.email;
                this.inputPax_company_payment   = agencyObject.companyName;

                this.checkValidity();
            }

        },  // eof mounted()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_FlagBookingPaymentIsReadyForOverview',
                'actn_setBookingProcessBookingObject',
                // >>> --------------------------
                'actn_setServicesProcessBookingObject', // (same for 'Services')
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSubmit()
            *
            * Desc: 'Payment Form' gets submitted.
            * Note: Send 'bookingCode' in 'BookingNoMode'.
            * Note:
            *
            * @param {Object} submitEvent (Event)
            * @return
            */
            onSubmit: function(submitEvent) {

                let me = this,
                    options = {},
                    myPaymentParams = {};


                me.$toc('>>> booking/payment/Payment.vue >>> onSubmit');
                options = {
                    container: 'body',
                    easing: 'linear',
                    offset: -60,
                    force: true,
                    cancelable: true,
                    onStart: function(element) {
                        // scrolling started
                    },
                    onDone: function(element) {
                        // scrolling is done
                    },
                    onCancel: function() {
                        // scrolling has been interrupted
                    },
                    x: false,
                    y: true
                };


                myPaymentParams.bookingKeyCode = this.getBookingLockfaresResults.keycode;
                myPaymentParams.isReservation = false,
                myPaymentParams.voucherCodes = [];

                // >>> -------------------------- 'customer'
                myPaymentParams.customer = {
                    address: submitEvent.target.elements['inputPax_address_payment'].value,
                    city: submitEvent.target.elements['inputPax_residence_payment'].value,
                    companyName: submitEvent.target.elements['inputPax_company_payment'].value,
                    countryCode: submitEvent.target.elements['inputPax_country_payment'].value,
                    email: submitEvent.target.elements['inputPax_email_payment'].value,
                    firstName: submitEvent.target.elements['inputPax_firstName_payment'].value,
                    lastName: submitEvent.target.elements['inputPax_lastName_payment'].value,
                    mobile: submitEvent.target.elements['inputPax_mobile_payment'].value,
                    phone: submitEvent.target.elements['inputPax_phone_payment'].value,
                    salutation: submitEvent.target.elements['inputPax_salutation_payment'].value,
                    zipCode:  submitEvent.target.elements['inputPax_plz_payment'].value
                };


                // >>> -------------------------- 'payment'
                myPaymentParams.payment = {};
                if (this.showCreditcard) {
                     myPaymentParams.payment.ccPayment = {
                        cc_brand: submitEvent.target.elements['inputPayment_cc_type'].value,
                        cc_cvc: submitEvent.target.elements['inputPayment_cc_cvc'].value,
                        cc_expiry_month: submitEvent.target.elements['inputPayment_cc_expirationmonth'].value,
                        cc_expiry_year: submitEvent.target.elements['inputPayment_cc_expirationyear'].value,
                        cc_holder: submitEvent.target.elements['inputPayment_cc_holder'].value,
                        cc_number: submitEvent.target.elements['inputPayment_cc_number'].value
                     }
                     myPaymentParams.payment.refererIP = "129.12.12.12";
                     myPaymentParams.payment.type = "CC";
                }
                if (this.showDebit) {
                    myPaymentParams.payment.ddPayment = {
                        bankaccount_holder: submitEvent.target.elements['inputPayment_dd_accountholder'].value,
                        bankaccount_no: submitEvent.target.elements['inputPayment_dd_iban'].value,
                        bankaccount_bankno: submitEvent.target.elements['inputPayment_dd_bic'].value,
                    }
                     myPaymentParams.payment.refererIP = "129.12.12.12";
                     myPaymentParams.payment.type = "DD";
                }
                if (this.showCash) {
                    // myPaymentParams.payment.csPayment = true;

                    myPaymentParams.payment.refererIP = "129.12.12.12";
                    myPaymentParams.payment.type = "CS";
                }
                if (this.isItAnOOPayment) {
                     myPaymentParams.payment.refererIP = "129.12.12.12";
                     myPaymentParams.payment.type = "OO";
                }


                // >>> --------------------------
                if (this.modulo ==='booking') {
                    // >>> -------------------------- 'passengers'
                    myPaymentParams.passengers = this.getBookingValidatePassengersObject.passengers; // catch (validated) pax & srvcs

                    // >>> -------------------------- Next Step..
                    this.actn_setBookingProcessBookingObject(myPaymentParams); // Save...
                }

                // >>> --------------------------
                if (this.modulo ==='services'  && this.get_areWeInServicesBookingNoMode === false) {
                    // >>> -------------------------- 'passengers'
                    let deepClone = JSON.parse(JSON.stringify(this.getServicesValidatePassengersObject.passengers));
                    myPaymentParams.passengers = deepClone; // catch (validated) pax & srvcs

                    // >>> -------------------------- Next Step..
                    delete myPaymentParams.bookingKeyCode; // not in 'services'
                    delete myPaymentParams.isReservation; // not in 'services'
                    delete myPaymentParams.voucherCodes; // not in 'services'
                    myPaymentParams.operatorBooking = null;

                    for (var i = 0; i < myPaymentParams.passengers.length; i++) { // not in 'services'
                        delete myPaymentParams.passengers[i].id_pax;
                    }

                    this.actn_setServicesProcessBookingObject(myPaymentParams); // Save...
                }


                // >>> --------------------------
                if (this.modulo ==='services' && this.get_areWeInServicesBookingNoMode === true) {
                    // >>> -------------------------- 'passengers'
                    myPaymentParams.passengers = this.getServicesValidatePassengersObjectClone.passengers; // catch (validated) pax & srvcs (clone)

                    // >>> -------------------------- Next Step..
                    delete myPaymentParams.bookingKeyCode;  // not in 'services'
                    delete myPaymentParams.isReservation;   // not in 'services'
                    delete myPaymentParams.voucherCodes;    // not in 'services'
                    myPaymentParams.operatorBooking = null;

                    // >>> Special: Mode: Bookinno --------
                    myPaymentParams = this.buildProcessBookingObjectForBookinnoSeatsOnly(myPaymentParams);
                    // <<< Special: Mode: Bookinno --------

                    this.actn_setServicesProcessBookingObject(myPaymentParams); // Save...
                }


                // >>> -------------------------- Last Step..
                me.$vp_m(); // Fake ...

                setTimeout(function(){
                    me.$vp_um();
                    me.$router.push({ path: '/overview/' + me.modulo });
                }, 1000);

                setTimeout(function() {
                    me.$scrollTo('#scrollPointTop', 200, options);
                }, 1500);

            }, // eof onSubmit()


            /*******************************************************************
            * onChangePaymentMethod()
            *
            * Desc:
            * Note: CC, DD ONLY!
            *
            * @param {Object} event
            * @return
            */
            onChangePaymentMethod: function(event) {

                var me = this;


                me.$toc('>>> booking/payment/Payment.vue >>> onChangePaymentMethod');
                if (event.target.value === 'cc') {
                    this.showCreditcard = true;
                    this.showDebit = false;
                    this.showCash = false;

                    this.actn_FlagBookingPaymentIsReadyForOverview(true);
                }

                if (event.target.value === 'dd') {
                    this.showDebit = true;
                    this.showCreditcard = false;
                    this.showCash = false;

                    this.actn_FlagBookingPaymentIsReadyForOverview(true);
                }


                if (event.target.value === 'cs') { // Cash Agency
                    this.showDebit = false;
                    this.showCreditcard = false;
                    this.showCash = true;

                    this.actn_FlagBookingPaymentIsReadyForOverview(true);
                }



                // >>> ---------------------------------------------------------
                if (event.target.value === '') {
                    this.showDebit = false;
                    this.showCreditcard = false;

                    this.actn_FlagBookingPaymentIsReadyForOverview(false);
                }

            }, // eof onChangePaymentMethod()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * buildSalutations()
            *
            * Desc: Build Array of 'Salutations' (trnsltd).
            *
            * @param
            * @return {Array}
            */
            buildSalutations: function() {

                var me = this,
                    salutations = [];


                me.$toc('>>> booking/payment/Payment.vue >>> buildSalutations');
                salutations.push(
                    { text: me.form_mr[me.getCurrentLocale], value: 'MR' },
                    { text: me.form_mrs[me.getCurrentLocale], value: 'MRS' },
                );

                return salutations;

            }, // eof buildSalutations()


            /*******************************************************************
            * buildCountries()
            *
            * Desc: Build Array of 'Countries'.
            *
            * @param
            * @return {Array}
            */
            buildCountries: function() {

                var me = this,
                    countries = [];


                me.$toc('>>> booking/payment/Payment.vue >>> buildCountries');
                countries.push(
                    { id: 'DE', country: 'Germany' 			},
                    { id: 'CH', country: 'Switzerland'		},
                    { id: 'AT', country: 'Austria'			},
                    { id: 'ES', country: 'Spain'			},
                    { id: 'FR', country: 'France'			},
                    { id: 'BE', country: 'Belgium'			},
                    { id: 'IT', country: 'Italy'			},
                    { id: 'GB', country: 'England'			},
                    { id: 'SY', country: 'Syria'			},
                    { id: 'US', country: 'United States'	},
                    { id: 'TR', country: 'Turkey'			},
                    { id: 'EG', country: 'Egypt'			},
                    { id: 'LB', country: 'Lebanon'			},
                    { id: 'LY', country: 'Libya'			},
                    { id: 'TS', country: 'Tunesien'			},
                    { id: 'MT', country: 'Malta'			},
                    { id: 'PL', country: 'Poland'			},
                    { id: 'RU', country: 'Russia'			},
                    { id: 'NL', country: 'Netherlands'		},
                    { id: 'NO', country: 'Norway'			},
                    { id: 'DK', country: 'Denmark'			},
                    { id: 'SE', country: 'Sweden'			},
                    { id: 'FI', country: 'Finland'			},
                    { id: 'PT', country: 'Portugal'			},
                    { id: 'BG', country: 'Bulgaria'			}
                );


                return countries;

            }, // eof buildCountries()


            /*******************************************************************
            * buildCreditcards()
            *
            * Desc: Build Array of 'Creditcard' Types.
            *
            * @param
            * @return {Array}
            */
            buildCreditcards: function() {

                var me = this,
                    cards = [];


                me.$toc('>>> booking/payment/Payment.vue >>> buildCreditcards');
                cards.push(
                    { id: 'VISA',	card: 'VISA'	},
                    { id: 'MASTER', card: 'MASTER'	},
                    // { id: 'AMEX',	card: 'AMEX'	}
                );


                return cards;

            }, // eof buildCreditcards()


            /*******************************************************************
            * buildMonths()
            *
            * Desc: Build Array of 'Months' (trnsltd).
            *
            * @param
            * @return {Array}
            */
            buildMonths: function() {

                var me = this,
                    months = [];


                me.$toc('>>> booking/payment/Payment.vue >>> buildMonths');
                months.push(
                    { text: me.january[me.getCurrentLocale], value: 1 },
                    { text: me.february[me.getCurrentLocale], value: 2 },
                    { text: me.march[me.getCurrentLocale], value: 3 },
                    { text: me.april[me.getCurrentLocale], value: 4 },
                    { text: me.may[me.getCurrentLocale], value: 5 },
                    { text: me.june[me.getCurrentLocale], value: 6 },
                    { text: me.july[me.getCurrentLocale], value: 7 },
                    { text: me.august[me.getCurrentLocale], value: 8 },
                    { text: me.september[me.getCurrentLocale], value: 9 },
                    { text: me.october[me.getCurrentLocale], value: 10 },
                    { text: me.november[me.getCurrentLocale], value: 11 },
                    { text: me.december[me.getCurrentLocale], value: 12 },
                );


                return months;

            }, // eof buildMonths()


            /*******************************************************************
            * buildYears()
            *
            * Desc: Build Array of 'Years'.
            * Note: +6Year in the Future. -2Years in the Past.
            *
            * @param
            * @return {Array}
            */
            buildYears: function(type) {

                let me = this,
                    startYear = moment().add(6, 'years').format('YYYY'),
                    // endYear = moment().subtract(2, 'years').format('YYYY'),
                    endYear = moment().format('YYYY'),
                    iyear = 0,
                    years = [];


                me.$toc('>>> booking/payment/Payment.vue >>> buildYears');
                for (iyear = startYear; iyear >= endYear; iyear -= 1) {
                    years.push(
                        { text:String(iyear), value: iyear },
                    );
                }


                return years;

            }, // eof buildYears()


            /*******************************************************************
            * buildProcessBookingObjectForBookinnoSeatsOnly()
            *
            * Desc:
            * Note: Special for Mode:Bookingno. Add Seats only.
            *
            * @param {Object} myPaymentParams
            * @return {Array}
            */
            buildProcessBookingObjectForBookinnoSeatsOnly: function(myPaymentParams) {

                var me = this,
                    services = [],
                    idsFlights = [];


                me.$toc('>>> booking/payment/Payment.vue >>> buildProcessBookingObjectForBookinnoSeatsOnly');
                myPaymentParams.passengers.forEach((pax, i) => {
                    if (pax.seatServices.length === 0) {                        // No new Seat
                        services = this.get_SeatFromOriginalBooking(pax.id_pax, idsFlights);
                        pax.seatServices.push(...services);
                    }

                    if (pax.seatServices.length !== 0) {                        // At least one new Seat
                        pax.seatServices.forEach((seat, i) => {
                            idsFlights.push(seat.idFlight);
                        });
                        services = this.get_SeatFromOriginalBooking(pax.id_pax, idsFlights);
                        pax.seatServices.push(...services);
                    }

                    idsFlights = []; // reset
                });


                // >>> --------------------------
                myPaymentParams.bookingCodeForModify = this.get_ServicesBookingnoSearchResults[0].bookingCode;   // coming from 'Overview'
                myPaymentParams.operatorBooking = this.get_ServicesUsersSearchDataBookingno.bookingCode;         // coming from 'Login'


                return myPaymentParams;

            }, // eof buildProcessBookingObjectForBookinnoSeatsOnly()


            /*******************************************************************
            * get_SeatFromOriginalBooking()
            *
            * Desc:
            * Note: Special for Mode:Bookingno. Add Seats only.
            * Note
            *
            * @param {Number} id_pax
            * @param {Array} idsFlights
            * @return {Object}
            */
            get_SeatFromOriginalBooking: function(id_pax, idsFlights) {

                var me = this,
                    services = [];


                me.$toc('>>> booking/payment/Payment.vue >>> get_SeatFromOriginalBooking');
                this.get_ServicesBookingnoSearchResults[0].passengers.forEach((pax, i) => {
                    if (parseFloat(pax.id_pax_own, 10) === parseFloat(id_pax, 10)) {
                        pax.outboundServices.forEach((srvcs, i) => {
                            if (srvcs.code === 'SEAT') {
                                if (!idsFlights.includes(this.getBookingFlightIdSelectedOutward)) {
                                    services.push({
                                        code: srvcs.code,
                                        comment: '',
                                        idFlight: this.getBookingFlightIdSelectedOutward,
                                        quantity: srvcs.quantity,
                                        tktClass: 'Y',
                                        infantOnLap: '',
                                        lockingCode: '',
                                        seatName: srvcs.seatName.seatName,
                                    });
                                }
                            }
                        });

                        pax.inboundServices.forEach((srvcs, i) => {
                            if (srvcs.code === 'SEAT') {
                                if (!idsFlights.includes(this.getBookingFlightIdSelectedReturn)) {
                                    services.push({
                                        code: srvcs.code,
                                        comment: '',
                                        idFlight: this.getBookingFlightIdSelectedReturn,
                                        quantity: srvcs.quantity,
                                        tktClass: 'Y',
                                        infantOnLap: '',
                                        lockingCode: '',
                                        seatName: srvcs.seatName.seatName,
                                    });
                                }
                            }
                        });
                    }
                });


                return services;

            }, // eof get_SeatFromOriginalBooking()


            /*******************************************************************
            * buildPayments()
            *
            * Desc: Build Array of allowed 'Payment Methods' (trnsltd).
            * Note: CC, DD ONLY! NEW: CS => AGENCY CASH
            *
            * @param
            * @return {Array}
            */
            buildPayments: function() {

                var me = this,
                    paymentMethods = [];


                me.$toc('>>> booking/payment/Payment.vue >>> buildPayments');
                if (this.modulo ==='booking') {
                    if (this.getBookingLockfaresResults.ccPaymentAllowed === true) {
                        paymentMethods.push(
                            { text: me.paymentmethod_cc[me.getCurrentLocale], value: 'cc' }
                        );
                    }
                    if (this.getBookingLockfaresResults.ddPaymentAllowed === true) {
                        paymentMethods.push(
                            { text: me.paymentmethod_dd[me.getCurrentLocale], value: 'dd' }
                        );
                    }
                    // Agency Cash
                    if (this.getBookingLockfaresResults.csPaymentAllowed === true) {
                        paymentMethods.push(
                            { text: me.paymentmethod_cs[me.getCurrentLocale], value: 'cs' }
                        );
                    }
                }


                if (this.modulo ==='services') {
                    if (this.getServicesBookingOptions.bookingOptions.CCpaymentAllowed === true) {
                        paymentMethods.push(
                            { text: me.paymentmethod_cc[me.getCurrentLocale], value: 'cc' }
                        );
                    }
                    if (this.getServicesBookingOptions.bookingOptions.DDpaymentAllowed === true) {
                        paymentMethods.push(
                            { text: me.paymentmethod_dd[me.getCurrentLocale], value: 'dd' }
                        );
                    }
                    // Agency Cash
                    if (this.getServicesBookingOptions.bookingOptions.CSpaymentAllowed === true) {
                        paymentMethods.push(
                            { text: me.paymentmethod_cs[me.getCurrentLocale], value: 'cs' }
                        );
                    }
                }


                return paymentMethods;

            }, // eof buildPayments()


            /*******************************************************************
            * checkValidity()
            *
            * Desc: Build Array of allowed 'Payment Methods' (trnsltd).
            * Note: Pays Attenion to: 'if agency is logged in => prefill'
            * Note: CC, DD ONLY!
            *
            * @param
            * @return {Array}
            */
            checkValidity: function() {

                var me = this,
                    formIsValid = false;


                me.$toc('>>> booking/payment/Payment.vue >>> checkValidity');
                // >>> CC/DD/OO ------------------------------------------------
                if (this.showCreditcard === true || this.showDebit === true || this.showCash === true || this.isItAnOOPayment === true ) {
                    if (!me.$v.inputPax_company_payment.$error) { // not required
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }

                    if (formIsValid) { // gets prefilled in 'Agency logged in'
                        if ((me.$v.inputPax_firstName_payment.$dirty || this.getFlagSharedAgencyLoggedIn) && !me.$v.inputPax_firstName_payment.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) { // gets prefilled in 'Agency logged in
                        if ((me.$v.inputPax_lastName_payment.$dirty || this.getFlagSharedAgencyLoggedIn) && !me.$v.inputPax_lastName_payment.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) { // gets prefilled in 'Agency logged in
                        if ((me.$v.inputPax_address_payment.$dirty || this.getFlagSharedAgencyLoggedIn) && !me.$v.inputPax_address_payment.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) { // gets prefilled in 'Agency logged in
                        if ((me.$v.inputPax_plz_payment.$dirty || this.getFlagSharedAgencyLoggedIn) && !me.$v.inputPax_plz_payment.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) { // gets prefilled in 'Agency logged in
                        if ((me.$v.inputPax_residence_payment.$dirty || this.getFlagSharedAgencyLoggedIn) && !me.$v.inputPax_residence_payment.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) {
                        if (!me.$v.inputPax_mobile_payment.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) { // gets prefilled in 'Agency logged in
                        if ((me.$v.inputPax_phone_payment.$dirty || this.getFlagSharedAgencyLoggedIn) && !me.$v.inputPax_phone_payment.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) { // gets prefilled in 'Agency logged in
                        if ((me.$v.inputPax_email_payment.$dirty || this.getFlagSharedAgencyLoggedIn) && !me.$v.inputPax_email_payment.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                }


                // >>> CC ------------------------------------------------------
                if (this.showCreditcard === true) {
                    if (formIsValid) {
                        //     if (me.$v.inputPayment_cc_holder.$dirty && !me.$v.inputPayment_cc_holder.$error) {
                        //         formIsValid = true;
                        //     } else {
                        //         formIsValid = false;
                        //     }
                        // }
                        // if (formIsValid) {
                        //     if (me.$v.inputPayment_cc_number.$dirty && !me.$v.inputPayment_cc_number.$error) {
                        //         formIsValid = true;
                        //     } else {
                        //         formIsValid = false;
                        //     }
                        // }
                        // if (formIsValid) {
                        //     if (me.$v.inputPayment_cc_cvc.$dirty && !me.$v.inputPayment_cc_cvc.$error) {
                        //         formIsValid = true;
                        //     } else {
                        //         formIsValid = false;
                        //     }
                        formIsValid = true;
                    }
                }

                // >>> DD ------------------------------------------------------
                if (this.showDebit === true) {
                    if (formIsValid) {
                        if (me.$v.inputPayment_dd_accountholder.$dirty && !me.$v.inputPayment_dd_accountholder.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) {
                        if (me.$v.inputPayment_dd_iban.$dirty && !me.$v.inputPayment_dd_iban.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) {
                        if (me.$v.inputPayment_dd_bic.$dirty && !me.$v.inputPayment_dd_bic.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                }


                // >>> CA ------------------------------------------------------ Cash: Agency
                if (this.showCash === true) {
                    if (formIsValid) {
                        formIsValid = true;
                    }
                }


                // >>> Trap ----------------------------------------------------
                if (!this.isItAnOOPayment) {
                    if (this.showCreditcard === false && this.showDebit === false && this.showCash === false) {
                        formIsValid = false;
                    }
                }


                return formIsValid;

            }, // eo checkValidity()

        }, // eo methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    /* .selector select {
        opacity: 1;
    } */

    input:focus {
        outline: none;
    }
    input.input-text:focus, textarea:focus, .selector select:focus + .custom-select {
        outline: none;
        border: 1px solid #d3e4f7;
        box-shadow: 0 0 8px #d3e4f7;
    }

    input.input-text.invalid {
        border: 1px solid red;
        background-color: #fdecf8;
    }
    .selector select.invalid {
        border: 1px solid red;
    }

    .errormsg {
        margin-bottom: 3px;
        margin-top: 3px;
        color: red;
    }


    .icon-check3 {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check3:after {
        content: "";
        position: absolute;
        top: 0;
        right: 10px;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #3b79b0;
    }





    /* >>> SearchResult iPAD -------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        h1 {
            font-size: 1.5em;
        }
        h2 {
            font-size: 1.4em;
        }
        button.btn-large, input[type="button"].button.btn-large, a.button.btn-large {
            font-size: 1.0em;
        }

        .booking-section {
            padding-top: 20px;
            padding-right: 15px;
            padding-bottom: 20px;
            padding-left: 15px;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/booking/payment/Payment.vue